import React from "react";

import { useLocation, useNavigate, useTranslation } from "utils";

import { Button, Icon, MainPage, Typography } from "components";

import { AgronomyUpsellPanel } from "pages/app/scenario-analysis/components/AgronomyUpsellPanel";
import { DownloadPrintCard } from "pages/app/scenario-analysis/components/DownloadPrintCard";
import { ScenarioPrintState } from "pages/app/scenario-analysis/utils/printState";

export const ScenariosNextStepsPage = () => {
  const { t } = useTranslation(["scenarioAnalysis", "meta"]);
  const navigate = useNavigate();
  const { state: locationState } = useLocation() as { state: ScenarioPrintState };

  const navigationCrumbs = {
    crumbs: [{ name: t("scenarioBuilder.navBreadcrumb"), link: "/scenarios" }, { name: t("nextSteps.breadcrumb") }],
    additionalData: <></>,
  };

  return (
    <MainPage fullWidth pageName="scenarios-next-steps" navigationCrumbs={navigationCrumbs} share={{ title: t("meta:soilSightNextSteps.title") }}>
      <div className="next-steps-page">
        <Button type="link" className="next-steps-back-btn" dataTestId="next-steps-back-btn" onClick={() => navigate("/scenarios")}>
          <Icon iconName="tabler/arrow-left" size="s" />
          {t("nextSteps.backButton")}
        </Button>

        <Typography variant="h2">{t("nextSteps.pageTitle")}</Typography>

        <div className="next-steps-cards-list">
          <div className="next-steps-card-wrapper">
            <AgronomyUpsellPanel />
          </div>
          <DownloadPrintCard printState={locationState} />
        </div>
      </div>
    </MainPage>
  );
};
